import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react'; // Or inline SVGs

export const ChefsNotes = ({ notes }: { notes: string }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      {/* Mobile View: Toggleable */}
      <div className="block sm:hidden">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center justify-between w-full bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white text-sm font-medium px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          <span>Chef's Notes</span>
          {isOpen ? (
            <ChevronUp className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
        </button>

        {isOpen && (
          <p className="mt-2 px-4 text-sm text-gray-700 dark:text-gray-300">
            {notes}
          </p>
        )}
      </div>

      {/* Desktop View: Always Visible */}
      <div className="hidden sm:block">
        <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-2">
          Chef's Notes
        </h3>
        <p className="text-sm text-gray-700 dark:text-gray-300">{notes}</p>
      </div>
    </div>
  );
};